import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Row, Col, Button, Form } from 'react-bootstrap';
import '../SignUp/SignUp.css';

const ForgotPassword = () => {
    const [email, setEmail] = useState('');
    const [isSubmitted, setIsSubmitted] = useState(false);

    const handleInputChange = (e) => {
        setEmail(e.target.value);
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!email) {
            alert('Please enter your email address!');
            return;
        }

        // Here you would typically send the reset request to your backend
        console.log('Password reset requested for:', email);
        setIsSubmitted(true);
    };

    const handleBackToForm = () => {
        setIsSubmitted(false);
        setEmail('');
    };

    return (
        <div className="common-container d-flex justify-content-center align-items-center p-3 overflow-hidden fw-regular">
            <div className="common-card overflow-hidden my-0 mx-auto d-flex flex-column">
                {/* Header */}
                <div className="common-header text-center position-relative">
                    <div className="logo mb-1 fw-bold">
                        <i className="fas fa-rocket" style={{ marginRight: '0.5rem' }}></i>
                        ProjectFlow
                    </div>
                    <div className="logo-subtitle fw-regular">Streamline Your Projects</div>
                </div>

                {/* Body */}
                <div className="common-body d-flex flex-column">
                    <h1 className="common-title fw-bold mb-3 text-center">Forgot Password?</h1>

                    {!isSubmitted ? (
                        <>
                            <div className="text-center">
                                <p className='mb-0'>No worries! Enter your email address and we'll send you a link to reset your password.</p>
                            </div>

                            {/* Forgot Password Form */}
                            <Form onSubmit={handleSubmit}>
                                <Row className="g-3 mt-3">
                                    <Col xs={12}>
                                        <Form.Group controlId="email">
                                            <Form.Label>Email Address</Form.Label>
                                            <Form.Control
                                                type="email"
                                                placeholder="Enter your email address"
                                                value={email}
                                                onChange={handleInputChange}
                                                required
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col xs={12} className='text-center'>
                                        <Button type="submit" className="btn-primary w-100 mb-4 mt-3">Send Reset Link </Button>
                                        <Link to="/login" className='btn btn-link text-decoration-none'>Back to Sign In</Link>
                                    </Col>
                                </Row>
                            </Form>
                            {/* Back Link */}
                        </>
                    ) : (
                        /* Success Message */
                        <div className="success-message show">
                            <div className="success-icon">
                                <i className="fas fa-check-circle"></i>
                            </div>
                            <h5>Check Your Email</h5>
                            <p>We've sent a password reset link to <strong>{email}</strong>. Please check your inbox and follow the instructions.</p>

                            <div className="success-actions">
                                <button onClick={handleBackToForm} className="btn-outline">
                                    Send Another Email
                                </button>
                                <div className="back-link" style={{ marginTop: '1rem' }}>
                                    <Link to="/login">Back to Sign In</Link>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ForgotPassword;
